import { put, call, takeLatest } from 'redux-saga/effects';

import {
  fetchFrameworkEvents,
  fetchFrameworkSummary,
  fetchFrameworkRegistry,
} from '../apis/notificationFramework';
import {
  getFrameworkEventsAction,
  getFrameworkEventsSuccess,
  getFrameworkEventsFailure,
  getFrameworkSummaryAction,
  getFrameworkSummarySuccess,
  getFrameworkSummaryFailure,
  getFrameworkRegistryAction,
  getFrameworkRegistrySuccess,
  getFrameworkRegistryFailure,
} from '../slices/notificationFramework';

const failureMessage = (error, fallback) =>
  error.response?.data?.error?.message || error.message || fallback;

function* getRegistry() {
  try {
    const response = yield call(fetchFrameworkRegistry);
    yield put(getFrameworkRegistrySuccess(response));
  } catch (error) {
    yield put(getFrameworkRegistryFailure(failureMessage(error, 'Failed to load registry')));
  }
}

function* getEvents(action) {
  try {
    const response = yield call(fetchFrameworkEvents, action.payload);
    yield put(getFrameworkEventsSuccess(response));
  } catch (error) {
    yield put(getFrameworkEventsFailure(failureMessage(error, 'Failed to load ledger')));
  }
}

function* getSummary(action) {
  try {
    const response = yield call(fetchFrameworkSummary, action.payload);
    yield put(getFrameworkSummarySuccess(response));
  } catch (error) {
    yield put(getFrameworkSummaryFailure(failureMessage(error, 'Failed to load summary')));
  }
}

export default function* notificationFrameworkSaga() {
  yield takeLatest(getFrameworkRegistryAction.type, getRegistry);
  yield takeLatest(getFrameworkEventsAction.type, getEvents);
  yield takeLatest(getFrameworkSummaryAction.type, getSummary);
}
